import { Box, Typography } from "@mui/material"

const TextInfoTicket = ({titulo, descripcion, onClick}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                mb: 1,
                gap: 2
            }}
            key={titulo}
        >
            <Typography sx={{
                color: '#2c3e50',
                fontWeight: 600,
                fontSize: 12,
                minWidth: 'fit-content',
                flexShrink: 0
            }}>
                {titulo}:
            </Typography>
            <Typography
                onClick={onClick}
                sx={{
                    color: onClick ? '#0364ff' : '#5d6b82',
                    fontWeight: 500,
                    fontSize: 12,
                    textAlign: 'right',
                    cursor: onClick ? 'pointer' : 'default',
                    wordBreak: 'break-word',
                    flex: 1,
                    '&:hover': onClick ? {
                        textDecoration: 'underline'
                    } : {}
                }}
                component='div'
            >
                {descripcion || '-'}
            </Typography>
        </Box>
    )
}

export default TextInfoTicket
